import type { AxiosRequestConfig, AxiosResponse } from 'axios';

export interface HttpResponse<T = unknown> {
  status: number;
  statusCode?: number;
  action?: ActionType;
  message?: string;
  content?: number;
  data?: T;
}

export interface SelfAxiosRequestConfig<D = any> extends AxiosRequestConfig<D> {
  noErrorPop?: boolean;
  noErrorToast?: boolean;
  responseOriginData?: boolean; // amis返回response处理数据
}

export interface SelfResponse<T = any, D = any>
  extends Omit<AxiosResponse<T, D>, 'config'> {
  config: SelfAxiosRequestConfig<D>;
}

// 后端接口返回的action值
export enum ActionType {
  alert = 1,
  dialog = 2,
  custom = 3,
  goToNotFound = 4,
  UPDATE_FAIL_ON_LOCK_EFFECT = 5, // 表示全量更新(商品/设计款/版单)时有的锁限制，导致更新失败
  STORE_IN_EXCESS = 6, // 生产入库超量限制
  PRODUCE_FINISH_EXCESS = 7, // 生产完成超量限制
}
